import { BaseHttpClient } from '../clients/base-http-client';
import { IGamePrediction, ILatestUpdate, ITeamPrediction } from '../models/interfaces/ipredictions';

export class NflPredictionsService extends BaseHttpClient {
    constructor() {
        super('/nfl/predictions');
    }

    public async getTeamPredictions(season: number, week: number): Promise<ITeamPrediction[]> {
        return await this.get<ITeamPrediction[]>({ url: `team-predictions/${season}`, params: { week } });
    }

    public async getGamePredictions(season: number, predictionWeek: number, week?: number): Promise<IGamePrediction[]> {
        return await this.get<IGamePrediction[]>({
            url: `game-predictions/${season}`,
            params: { week, predictionWeek },
        });
    }

    public async getLatestUpdate(season: number): Promise<ILatestUpdate> {
        return await this.get<ILatestUpdate>({ url: `latest-update/${season}` });
    }
}
